// export default {
//     // getCusMsgTemplateConfig:'', //获取模板信息
//     // getTemplateFieldsInfo:'',//自定义字段
//     // getUserTicketInfoList:'',//留言列表
//     // postMsg:'',//添加留言
//     // getUserDealTicketInfoList:'',//获取留言详情
//     // isMessage:'',//是否留言
//     // postMsgAfterVerify:'/chat/data/postMsgAfterVerify.action',
//     // addTicketSatisfactionScoreInfo:'/chat-web/invoke/addTicketSatisfactionScoreInfo.action',
//     // getTicketTypeInfoList:''//查询分类接口
// }
import axios from 'axios';
import { stringify } from 'qs';
// 获取模板信息
export async function getCusMsgTemplateConfig(params) {
  return axios.get(`/chat-web/invoke/getCusMsgTemplateConfig.action?${stringify(params)}`);
}
// 留言列表
export async function getUserTicketInfoList(params) {
  return axios.get(`/chat-web/user/getUserTicketInfoList.action?${stringify(params)}`);
}
// 自定义字段
export async function getTemplateFieldsInfo(params) {
  return axios.get(`/chat-web/invoke/getTemplateFieldsInfo.action?${stringify(params)}`);
}
// 获取留言详情
export async function getUserDealTicketInfoList(params) {
  return axios.get(`/chat-web/invoke/getUserDealTicketInfoList.action?${stringify(params)}`);
}
// 查询分类接口
export async function getTicketTypeInfoList(params) {
  return axios.get(`/chat-web/invoke/queryTicketTypeInfoList.action?${stringify(params)}`);
}
// 添加留言
export async function postMsg(params) {
  return axios.post(`/chat/data/postMsg.action`,params);
}
// 是否留言
export async function isMessage(params) {
  return axios.post(`/chat/data/isMessage.action`,params);
}
// 
export async function postMsgAfterVerify(params) {
  return axios.post(`/chat/data/postMsgAfterVerify.action`,params);
}
// /chat-web/invoke/addTicketSatisfactionScoreInfo.action
export async function addTicketSatisfactionScoreInfo(params) {
  return axios.post(`/chat-web/invoke/addTicketSatisfactionScoreInfo.action`,params);
}
// 提交回复
export async function invokeOtherByUser(params) {
  return axios.post(`/chat-web/data/invokeOtherByUser.action`,params);
}
// 撤销工单
export async function revokeWorkOrder(params) {
  return axios.post(`/chat-web/data/invokeOtherByUser.action`,params);
}
// 发送邮箱验证
export async function sendShortEmailMessage(params) {
  return axios.post(`/chat-web/data/sendShortEmailMessage`,params);
}
// 验证邮箱验证码
export async function verifyShortEmailMessage(params) {
  return axios.post(`/chat-web/data/verifyShortEmailMessage`,params);
}